<div class="ifa-navigation" *ngIf="!globals.hideHeaderFooter">
    <div class="ifa-utility">
        <div class="container-fluid ifa-nav-shell d-flex align-items-center justify-content-between">
            <a class="ifa-phone" href="tel:+1{{globals.phoneTollFree}}" (click)="adwordsEvent()">
                <fa-icon [icon]="['fas', 'phone-alt']" aria-hidden="true"></fa-icon>
                {{globals.phoneTollFree}} <span class="ifa-toll-free">(Toll Free)</span>
            </a>
            <nav class="ifa-utility-disclosures d-flex align-items-center" aria-label="Disclosures">
                <a href="https://www.ifa.com/pdfs/ifa-form-crs.pdf" target="_blank" rel="noopener">Form CRS</a>
                <a routerLink="/disclosures">Back-testing Disclosures</a>
                <div class="ifa-utility-dropdown">
                    <a class="ifa-utility-dropdown-toggle" routerLink="/disclosures/index-data" (click)="blurTarget($event)">Time-Series Descriptions</a>
                    <ul class="ifa-utility-submenu list-unstyled">
                        <li><a routerLink="/disclosures/index-data" (click)="blurTarget($event)">Index Descriptions</a></li>
                        <li><a routerLink="/disclosures/fund-data" (click)="blurTarget($event)">Fund Descriptions</a></li>
                    </ul>
                </div>
            </nav>
            <div class="ifa-utility-resources d-flex align-items-center">
                <a routerLink="/glossary">Glossary</a>
                <a class="ifa-store" routerLink="/store" target="_blank" rel="noopener">Store</a>
            </div>
            <div class="ifa-utility-links d-flex align-items-center">
                <button class="btn ifa-search-toggle" id="ifa-search-toggle" type="button" (click)="toggleSearch($event)"
                    [attr.aria-expanded]="searchOpen" aria-controls="ifa-search-row">
                    Search <fa-icon [icon]="['fas', 'search']" aria-hidden="true"></fa-icon>
                </button>
                <a routerLink="/login">Client Login</a>
            </div>
        </div>
    </div>

    <div class="ifa-search-row collapse" id="ifa-search-row" [class.show]="searchOpen">
        <form class="d-flex gap-2 mx-auto" role="search" (submit)="$event.preventDefault(); searchIFA()">
            <label class="visually-hidden" for="site_search">Search IFA.com</label>
            <input class="form-control" id="site_search" type="search" placeholder="Search IFA.com"
                #searchTerm required minlength="2" autocomplete="off">
            <button class="btn ifa-nav-cta" type="submit" aria-label="Submit search" title="Search">
                <fa-icon [icon]="['fas', 'search']" aria-hidden="true"></fa-icon>
            </button>
        </form>
    </div>

    <header class="ifa-site-header">
        <div class="container-fluid ifa-nav-shell ifa-header-row d-flex align-items-center">
            <a routerLink="/" class="navbar-brand ifa-nav-logo" aria-label="Index Fund Advisors home" (click)="closeNavigation()">
                <img [src]="logoSrc" width="72" height="72" alt="Index Fund Advisors logo">
            </a>
            <nav class="ifa-desktop-nav flex-grow-1" aria-label="Main navigation">
                <ul class="nav align-items-center justify-content-between flex-nowrap">
                    <li class="nav-item" *ngFor="let section of navigationSections; let sectionIndex = index"
                        (pointerenter)="hoverOpenMenu(sectionIndex, $event)" (pointerleave)="hoverCloseMenu($event)">
                        <button class="nav-link ifa-nav-toggle dropdown-toggle" type="button"
                            [id]="'ifa-menu-toggle-' + sectionIndex" [attr.aria-controls]="'ifa-mega-' + sectionIndex"
                            [attr.aria-expanded]="activeMenu === sectionIndex" (click)="toggleMenu(sectionIndex, $event)"
                            (keydown.arrowdown)="$event.preventDefault(); focusMenu(sectionIndex)">
                            {{section.title}}
                        </button>
                    </li>
                </ul>
            </nav>
            <a routerLink="/find-an-advisor" class="btn ifa-nav-cta ifa-header-cta" (click)="closeNavigation()">Schedule a Conversation</a>
            <button class="btn ifa-mobile-toggle" id="ifa-mobile-toggle" type="button" (click)="openOffCanvas()"
                aria-controls="offcanvasRight" [attr.aria-expanded]="mobileOpen" aria-label="Open navigation" title="Open navigation">
                <fa-icon [icon]="['fas', 'bars']" aria-hidden="true"></fa-icon>
            </button>
        </div>

        <section class="dropdown-menu ifa-mega" *ngFor="let section of navigationSections; let sectionIndex = index"
            [id]="'ifa-mega-' + sectionIndex" [class.show]="activeMenu === sectionIndex"
            [attr.aria-labelledby]="'ifa-menu-toggle-' + sectionIndex"
            (pointerenter)="cancelHoverTimers()" (pointerleave)="hoverCloseMenu($event)">
            <div class="container-fluid ifa-nav-shell">
                <div class="d-flex justify-content-end mb-3">
                    <button class="btn-close" type="button" [attr.aria-label]="'Close ' + section.title + ' menu'"
                        title="Close menu" (click)="closeMenu(true)"></button>
                </div>
                <div class="row g-4">
                    <div class="col-3" *ngFor="let column of section.columns">
                        <h2>{{column.title}}</h2>
                        <ng-container *ngTemplateOutlet="navigationLinks; context: { $implicit: column.links }"></ng-container>
                    </div>
                </div>
            </div>
        </section>
    </header>

    <div class="offcanvas offcanvas-end ifa-mobile-drawer" tabindex="-1" id="offcanvasRight" #offcanvasRight
        aria-labelledby="offcanvasRightLabel">
        <div class="offcanvas-header">
            <h2 class="offcanvas-title" id="offcanvasRightLabel">Menu</h2>
            <button class="btn-close" type="button" aria-label="Close navigation" title="Close navigation" (click)="closeOffCanvas()"></button>
        </div>
        <div class="offcanvas-body">
            <nav aria-label="Mobile navigation">
                <a class="ifa-mobile-home" routerLink="/" (click)="closeNavigation()">Home</a>
                <div class="accordion accordion-flush">
                    <div class="accordion-item" *ngFor="let section of navigationSections; let sectionIndex = index">
                        <h3 class="accordion-header">
                            <button class="accordion-button" type="button" [class.collapsed]="activeMobileMenu !== sectionIndex"
                                [id]="'ifa-mobile-heading-' + sectionIndex" [attr.aria-controls]="'ifa-mobile-section-' + sectionIndex"
                                [attr.aria-expanded]="activeMobileMenu === sectionIndex"
                                (click)="activeMobileMenu = activeMobileMenu === sectionIndex ? null : sectionIndex">
                                {{section.title}}
                            </button>
                        </h3>
                        <div class="accordion-collapse collapse" [id]="'ifa-mobile-section-' + sectionIndex"
                            [class.show]="activeMobileMenu === sectionIndex" [attr.aria-labelledby]="'ifa-mobile-heading-' + sectionIndex">
                            <div class="accordion-body">
                                <div class="ifa-mobile-column" *ngFor="let column of section.columns">
                                    <h4>{{column.title}}</h4>
                                    <ng-container *ngTemplateOutlet="navigationLinks; context: { $implicit: column.links }"></ng-container>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <a routerLink="/find-an-advisor" class="btn ifa-nav-cta w-100 mt-4" (click)="closeNavigation()">Schedule a Conversation</a>
            </nav>
        </div>
    </div>

    <ng-template #navigationLinks let-links>
        <ul class="list-unstyled ifa-menu-links mb-0">
            <li *ngFor="let link of links">
                <a *ngIf="!link[1].startsWith('https://'); else externalLink" [routerLink]="link[1].split('#')[0]"
                    [fragment]="link[1].split('#')[1]" [target]="link[2] || '_self'" [attr.rel]="link[2] ? 'noopener' : null" (click)="closeNavigation()">{{link[0]}}</a>
                <ng-template #externalLink>
                    <a [href]="link[1]" [attr.target]="link[2] || null" [attr.rel]="link[2] ? 'noopener' : null"
                        (click)="closeNavigation()">{{link[0]}}</a>
                </ng-template>
            </li>
        </ul>
    </ng-template>
</div>